export default __webpack_public_path__ + "40d50e6cbd67a2dbf8ec9eb2121d21ac.png";